import { initialStyles, Modal } from '@/components/modal/Modal'
const modalStyle = {
  ...initialStyles,
  content: {
    ...initialStyles.content,
    width: '500px',
    borderRadius: '10px',
  },
}
interface Props {
  isOpen: boolean
  title: string
  message: string
  buttonText: string
  onClose: () => void
  onClickButton: () => void
}
export const SchoolSurveyMessageModal: React.FC<Props> = ({
  isOpen,
  title,
  message,
  buttonText,
  onClose,
  onClickButton,
}) => {
  return (
    <Modal open={isOpen} onRequestClose={onClose} style={modalStyle}>
      <div className="py-5">
        <p className="text-2xl font-normal tracking-normal leading-9 text-center text-black opacity-100">
          {title}
        </p>
      </div>
      <div className="px-5 mb-10">
        <p className="text-base font-normal tracking-normal leading-6 text-center text-[#333] opacity-100">
          {message}
        </p>
      </div>
      <div className="px-5 pb-5 text-center">
        <button
          className="w-[152px] h-11 text-[15px] font-normal tracking-normal leading-6 text-white uppercase bg-[#316ab0] rounded-[50px] border-none opacity-100"
          onClick={onClickButton}
        >
          {buttonText}
        </button>
      </div>
    </Modal>
  )
}
